// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Lucide swaps <i data-lucide> placeholders for SVGs; re-run whenever Turbo renders new HTML
const renderIcons = () => window.lucide?.createIcons()
document.addEventListener("turbo:load", renderIcons)
document.addEventListener("turbo:frame-load", renderIcons)
document.addEventListener("turbo:render", renderIcons)
